<div class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--extra-light"
      size="2x"></app-loading-icon>
  </div>
</div>
